//布局组件内部组件可配置项修改事件处理函数
function handleFindLayoutComponentOptions(options, uid, cb) {
  let _rows = options
  let _outStatus = false
  if (_rows) {
    _rows.forEach(rowsItem => {
      if (rowsItem && rowsItem.cols && !_outStatus) {
        let itemCols = rowsItem.cols
        itemCols.forEach(colsItem => {
          if (colsItem.uid === uid) {
            _outStatus = true
            cb(colsItem)
            return
          }
          if (colsItem.uid !== uid && colsItem.rows !== null) {
            handleFindLayoutComponentOptions(colsItem.rows, uid, cb)
          }
        })
      } else return
    })
  }
}

export default {
  getLayoutOptions: state => data => {
    if (data.container_id === null || data.rect_id === null || data.uid === null || data.elementInLayoutId === null) {
      throw new Error("Some data is null, its incomplete,found in state/stage/mutations/getLayoutOptions")
    }
    let result = null
    let tempRect = JSON.parse(
      JSON.stringify(
        state.page.children
          .find(i => i.container_id === data.container_id)
          .children.find(i => i.rect_id === data.rect_id).options.rows
      )
    )
    handleFindLayoutComponentOptions(tempRect, data.uid, colsItem => {
      result = colsItem.elementOptions.find(it => it.elementInLayoutId === data.elementInLayoutId)
    })
    return result
  }
}
